import { render, staticRenderFns } from "./GameCardPlaceholder.vue?vue&type=template&id=5afda3d9&scoped=true&lang=pug&"
import script from "./GameCardPlaceholder.vue?vue&type=script&lang=js&"
export * from "./GameCardPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./GameCardPlaceholder.vue?vue&type=style&index=0&id=5afda3d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afda3d9",
  null
  
)

export default component.exports